import { forwardRef, memo } from 'react';

import { ChevronUpIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

export type AnnouncementCollapseButtonProps = {
  onCollapse: () => void;
};

export const AnnouncementCollapseButton = memo(
  forwardRef<HTMLButtonElement, AnnouncementCollapseButtonProps>(({ onCollapse }, ref) => {
    return (
      <IconButton
        adsIcon
        appearance="ghost"
        aria-expanded={true}
        className="shrink-0"
        color="gray"
        data-testid="ANNOUNCEMENT_COLLAPSE_BUTTON"
        icon={ChevronUpIcon}
        label="Collapse announcement"
        onClick={onCollapse}
        ref={ref}
        size="small"
      />
    );
  }),
);

AnnouncementCollapseButton.displayName = 'AnnouncementCollapseButton';
